import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODATA_COUNT_KEY, ODataService, } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var SessionsService = /** @class */ (function (_super) {
    tslib_1.__extends(SessionsService, _super);
    function SessionsService(http) {
        var _this = _super.call(this, http, MapperService.sessionMap) || this;
        _this._endpoint = '/odata/Sessions';
        _this.suggest = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = tslib_1.__assign({}, _this._getSuggestOptions('Name', searchTerm, fetchSize, skip), { expand: ['Robot'], select: ['Robot'], orderBy: ["Robot/Name"] });
            return _this.get(queryOptions)
                .pipe(map(function (_a) {
                var data = _a.data, total = _a.total;
                return ({
                    total: total,
                    data: data.map(function (session) { return ({
                        id: session.robot.id,
                        text: session.robot.name,
                    }); }),
                });
            }));
        };
        _this.userNameSuggest = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = _this._getSuggestOptions('Username', searchTerm, fetchSize, skip);
            var endpoint = _this._endpoint + "/UiPath.Server.Configuration.OData.GetUsernames" + _this.getQueryString(queryOptions);
            return _this._http
                .get(endpoint)
                .pipe(map(function (res) { return ({
                data: res.value.map(function (userName) { return ({
                    id: userName,
                    text: userName,
                }); }),
                total: res[ODATA_COUNT_KEY],
            }); }));
        };
        _this.robotsByUsernameSuggest = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = _this._getSuggestOptions('Username', searchTerm, fetchSize, skip);
            var endpoint = _this._endpoint + "/UiPath.Server.Configuration.OData.GetUserRobots" + _this.getQueryString(queryOptions);
            return _this._http
                .get(endpoint)
                .pipe(map(function (res) { return ({
                data: res.value.map(function (_a) {
                    var UserName = _a.UserName, RobotNames = _a.RobotNames;
                    return ({
                        id: RobotNames,
                        text: UserName,
                    });
                }),
                total: res[ODATA_COUNT_KEY],
            }); }));
        };
        return _this;
    }
    SessionsService.prototype.getSessionsForEnvironment = function (environmentId, queryOptions) {
        if (queryOptions.expand instanceof Array &&
            !queryOptions.expand.includes('Robot')) {
            queryOptions.expand.push('Robot');
        }
        else {
            queryOptions.expand = ['Robot'];
        }
        Object.assign(queryOptions.filter, {
            Robot: {
                Environments: {
                    any: {
                        Id: environmentId,
                    },
                },
                Type: {
                    ne: 'Attended',
                },
            },
        });
        return this.get(queryOptions);
    };
    SessionsService.prototype.getNonAttendedRobotInEnvironment = function (environmentId, robotId) {
        var queryOptions = {
            expand: ['Robot'],
            filter: {
                Robot: {
                    Environments: {
                        any: {
                            Id: environmentId,
                        },
                    },
                    Id: {
                        eq: robotId,
                    },
                    Type: {
                        ne: 'Attended',
                    },
                },
            },
        };
        return this.get(queryOptions);
    };
    SessionsService.prototype.getByMachineId = function (machineId, queryOptions) {
        queryOptions.expand = ['Robot'];
        queryOptions.filter['MachineId'] = machineId;
        return this.get(queryOptions);
    };
    SessionsService.prototype._getSuggestOptions = function (property, searchTerm, fetchSize, skip) {
        var _a;
        if (property === void 0) { property = 'Name'; }
        if (searchTerm === void 0) { searchTerm = ''; }
        if (fetchSize === void 0) { fetchSize = 20; }
        if (skip === void 0) { skip = 0; }
        return {
            top: fetchSize,
            skip: skip,
            filter: {
                Robot: (_a = {},
                    _a[property] = {
                        contains: searchTerm,
                    },
                    _a),
            },
        };
    };
    return SessionsService;
}(ODataService));
export { SessionsService };
